import { fromJS } from 'immutable';
import actionTypes from '../../actions/actionTypes'
import requestStatus from '../../constants/requestStatus'
import { NEWSPAPER_DEFAULT } from '../../constants/state';
import { addItemToArray, deleteItemFromArray, returnStateIfNoAction } from '../helpers';
import { CHOOSENMOVIES, CUSTOMITEMS, MOVIE } from '../../constants/itemTypes';


const getInitState = weeks => {
    return fromJS({
        status: requestStatus.INITIALIZED,
        error: null,
        weeks: weeks,
        currentWeek: weeks[1],
        ... NEWSPAPER_DEFAULT
    })
}

const onGet = (state, action) =>  state.set('status', requestStatus.REQUEST_PENDING)
                                        .set('error', '')

const onGetSuccess = (state, action) => {
    const { newspaper } = action.payload

    delete  newspaper.status
    delete newspaper.error

    return fromJS({
        status: requestStatus.REQUEST_SUCCESS,
        error: '',
        ... newspaper
    })
}

const onUpdateSuccess = (state, action) => {
    const { newspaper } = action.payload

    return fromJS({
        ... newspaper
    })
}

const onSuccess = (state, action) => state.set('status', requestStatus.REQUEST_SUCCESS)
                                          .set('error', '')


const onError = (state, action) => state.set('status', requestStatus.REQUEST_ERROR)
                                        .setIn(['error'], action.payload.errorMessage)


const onReset = (state) => state.set('status', requestStatus.INITIALIZED)
                                .set('error', null)

const setCustomDateSettings = (state, action) => {
    const {dateObj} = action.payload

    return state.setIn(['dateSettings'], dateObj)
}

const updateNewspaperSettings = (state, action) => {
    const {payload} = action.payload

    return state.setIn(["newspaperAnnouncementSettings"], payload)
}

const updateNewspaperOrder = (state, action) => {
    const { order, type } = action.payload
    
    return state.setIn([type, 'order'], order)
}

const addNewspaperItem = (state, action) => {
    const { item, itemType } = action.payload
    let keyArray = [itemType]
    
    if(itemType === 'customItemsNew') {
        keyArray = ['customItems']
        return state.setIn([...keyArray, ...[ 'items', item.id]], item)
    } else if(itemType === MOVIE) {
        keyArray = ['choosenMovies']
        const stateWithItem = state.setIn([...keyArray, ...[ 'items', item.id]], item)
        keyArray.push('order')
        
        return addItemToArray(stateWithItem, keyArray, item.id)

    } else if (itemType === CUSTOMITEMS) {    
        keyArray = ['bottomItems']
        const stateWithItem = state.setIn([...keyArray, ...[ 'items', item.id]], item)
        keyArray.push('order')
    
        return addItemToArray(stateWithItem, keyArray, item.id)
    } else { 
        const stateWithItem = state.setIn([...keyArray, ...[ 'items', item.id]], item)
        keyArray.push('order')
    
        return addItemToArray(stateWithItem, keyArray, item.id)
    }
}

const updateNewspaperItem = (state, action) => {
    const { item, itemType } = action.payload
    let keyArray = [itemType]

    return state.setIn([...keyArray, ...['items', item.id]], item)
}

const deleteNewspaperItem = (state, action) => {
    const { itemId, itemType } = action.payload

    let keyArray = [itemType]
    const stateWithoutItem = state.deleteIn([...keyArray, ...[ 'items', itemId]])

    keyArray.push('order')

    return deleteItemFromArray(stateWithoutItem, keyArray,  itemId)
}

const newspaperReducer = weeks => (state = getInitState(weeks), action) => {
    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.PRINT_DATA_GET_REQUEST:
        case actionTypes.PRINT_DATA_NEWSPAPER_PDF_REQUEST:
            return onGet(state);
        case actionTypes.PRINT_DATA_GET_SUCCESS:
            return onGetSuccess(state, action).set('hasChanges', false);
        case actionTypes.PRINT_DATA_UPDATE_SUCCESS:
            return onUpdateSuccess(state, action).set('hasChanges', false);
        case actionTypes.PRINT_DATA_NEWSPAPER_PDF_SUCCESS:
            return onSuccess(state)
        case actionTypes.PRINT_DATA_GET_ERROR:
        case actionTypes.PRINT_DATA_NEWSPAPER_PDF_ERROR:
            return onError(state, action);
        case actionTypes.PRINT_DATA_NEWSPAPER_PDF_RESET:
            return onReset(state)

        case actionTypes.PRINT_LOCAL_DATA_NEWSPAPER_UPDATE_CURRENT_WEEK:
            return state.set('currentWeek', action.payload.week).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_NEWSPAPER_ADD_DATE_SETTINGS:
            return setCustomDateSettings(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_NEWSPAPER_UPDATE_NEWSPAPER_SETTINGS:
            return updateNewspaperSettings(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_NEWSPAPER_UPDATE_NEWSPAPER_ORDER:
            return updateNewspaperOrder(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_NEWSPAPER_ADD_NEWSPAPER_ELEMENT:
            return addNewspaperItem(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_NEWSPAPER_UPDATE_NEWSPAPER_ELEMENT:
            return updateNewspaperItem(state, action).set('hasChanges', true);
        case actionTypes.PRINT_LOCAL_DATA_NEWSPAPER_DELETE_NEWSPAPER_ELEMENT:
            return deleteNewspaperItem(state, action).set('hasChanges', true);
        default:
            return state;
    }
}


export default newspaperReducer;